<template>
  <div>
    <v-container >
      <v-container >
      <v-row class="elevation-1">
        <v-col>
          <v-select id="input-text-size"
          class="input-text-size"
            v-model="reportConfig"
            :items="reports"
            item-text="description"
            item-value="config"
            label="Type of report"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showDates')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.fromDate"
            label="From Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.toDate"
            label="To Date"
            class="input-text-size"
            :isToggle = "false"
            />

        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showActiveOnly') || showReportConfig('showExpiredOnly')">
        <v-col cols="6" v-if="showReportConfig('showActiveOnly')">
          <v-checkbox
            v-model="criteria.isActive"
            label="Active warrants only"
            class="input-text-size"
            dense
            hide-details
          />
        </v-col>
        <v-col cols="6" v-if="showReportConfig('showExpiredOnly')">
          <v-checkbox
            v-model="criteria.expiredOnly"
            label="Expired only (active, issued more than 60 days ago)"
            class="input-text-size"
            dense
            hide-details
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1"
        v-if="showReportConfig('showIssueDate')">
        <v-col cols="6">
          <ClarionDateControl
            v-model="criteria.issueDate"
            label="Issue Date"
            class="input-text-size"
            :isToggle = "false"
            />
        </v-col>
      </v-row>
        <v-row class="elevation-1"
        v-if="showReportConfig('showTaxYears')">
        <v-col cols="6">
               <MultiItemSelect
                class="input-text-size"
                  label="By Tax Year"
                  item-text="taxYear"
                  item-value="taxYear"
                  :item-list="taxYearsList"
                  :items="criteria.taxYears"
                  @selected-items="selectedTaxYears"
                />
        </v-col>
      </v-row>
      <!-- Reprint a run by the numbers it issued. An exact Issue Date could not express
           "#2500362 through #2500453", which is how a county refers to a batch. -->
      <v-row class="elevation-1" v-if="showReportConfig('showWarrantNumberRange')">
        <v-col cols="6">
          <v-text-field
            class="input-text-size report-from-warrant-number"
            label="From Warrant #"
            type="number"
            v-model.number="criteria.fromWarrantNumber" />
        </v-col>
        <v-col cols="6">
          <v-text-field
            class="input-text-size report-to-warrant-number"
            label="To Warrant #"
            type="number"
            v-model.number="criteria.toWarrantNumber" />
        </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showNotPrinted')">
        <v-col cols="6">
          <v-select
            class="input-text-size report-not-printed-select"
            label="Not yet printed"
            :items="notPrintedOptions"
            item-text="text"
            item-value="value"
            clearable
            v-model="criteria.notPrinted" />
        </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showTaxType')">
        <v-col cols="6">
          <MultiItemSelect
            class="input-text-size"
            label="Tax Type"
            item-text="name"
            item-value="value"
            :item-list="taxTypes"
            :items="criteria.taxType"
            @selected-items="selectedTaxTypes"
          />
        </v-col>
      </v-row>
      <v-row class="elevation-1" v-if="showReportConfig('showTaxDistricts')">
        <v-col>
          <MultiItemSelect
            class="input-text-size"
            label="By Tax Districts"
            item-text="taxDistrictCodeAndName"
            item-value="districtCode"
            :item-list="taxDistrictList"
            :items="criteria.taxDistricts"
            @selected-items="selectedTaxDistricts"
          />
        </v-col>
      </v-row>
      <v-row>
        <ReportChip
          :to="reportConfig.route"
          :queryString="queryString"
          :isValid="validateCriteria"
          caption="View Report"
        />
      </v-row>
    </v-container>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ReportChip from '../../../reports/ReportChip.vue';
import ClarionDateControl from '../../../common/ClarionDateControl.vue';
import { queryStringCalc, delenquentReportList } from './report-util';
import { getRawJwt } from '../../../../util/jwt';
import MultiItemSelect from '../../../common/base/MultiItemSelect.vue';
import { typesDefination } from '../util';
import { toShortDate } from '../../../../util/shared/tmc-global';

const taxDistrictBaseCrudKey = 'sharedTaxDistrict';

export default {
  name: 'DelenquentTaxReport',
  components: {
    ReportChip,
    ClarionDateControl,
    MultiItemSelect,

  },
  data: () => ({
    taxYearRange: [],
    // The warrant form and the letter are missed independently, so each is its own answer
    // rather than one "printed?" flag covering both.
    notPrintedOptions: [
      { text: 'Warrant form not printed', value: 'form' },
      { text: 'Letter not printed', value: 'letter' },
    ],
    criteria: {
      taxDistricts: [],
      adjTypes: [],
      taxYears: [],
      taxType: [],
      fromDate: toShortDate(),
      toDate: toShortDate(),
      // Deliberately NOT defaulted to today. An exact Issue Date of "today" silently
      // returns nothing for the batch a county raised yesterday, and it defeats the
      // warrant number range below - the filter Tulsa actually asked for. Empty means
      // "any issue date", so the report opens showing everything.
      issueDate: null,
      isActive: false,
      expiredOnly: false,
      fromWarrantNumber: null,
      toWarrantNumber: null,
      notPrinted: null,
    },
    reportConfig: {
      route: '',
      filters: {},
    },
    criteriaStats: {
      allTaxDistricts: false,
      allTaxYears: false,
    },
    taxTypes: [],
    defaultCriteria: {
      fy: undefined,
    },
    // taxYearsList: [],
  }),
  created() {
    this.loadTaxDistricts();
    this.initializeTaxYear();
    this.loadTaxTypes();
    // this.loadAdjCodes();
  },

  computed: {
    ...mapGetters('base/crud', ['items']),
    reports() {
      return [
        ...delenquentReportList(),
      ];
    },
    taxDistrictList() {
      return (this.items(taxDistrictBaseCrudKey) || []).map((i) => ({
        ...i,
        taxDistrictCodeAndName: `${i.districtCode} ${i.districtName || ''}`,
      }));
    },

    /**
     * "Everything is selected" is the same thing as "no filter", and saying it the short
     * way matters here: this county has 187 tax districts, which spell out to a 1.6KB
     * query string, and a warrant whose tax record cannot be resolved would be dropped
     * from a report the user had not actually narrowed.
     */
    reportParams() {
      const allDistricts = this.criteriaStats.allTaxDistricts;
      const allTypes = this.criteriaStats.allTaxTypes;
      return {
        fromDate: this.criteria.fromDate,
        toDate: this.criteria.toDate,
        issueDate: this.criteria.issueDate,
        taxYears: (this.criteria.taxYears || []).join(','),
        taxDistrictCodes: allDistricts ? '' : (this.criteria.taxDistricts || []).join(','),
        taxTypes: allTypes ? '' : (this.criteria.taxType || []).join(','),
        adjustmentCodes: (this.criteria.adjTypes || []).join(','),
        isActive: this.criteria.isActive,
        expiredOnly: this.criteria.expiredOnly,
        fromWarrantNumber: this.criteria.fromWarrantNumber,
        toWarrantNumber: this.criteria.toWarrantNumber,
        notPrinted: this.criteria.notPrinted,
      };
    },
    queryString() {
      return queryStringCalc({
        reportConfig: this.reportConfig,
        params: this.reportParams,
        criteria: this.criteria,
        token: this.getAuthToken,
        defaultCriteria: this.defaultCriteria,
        devSetting: this.devSettingItem,
        criteriaStats: this.criteriaStats,
      });
    },
    // A report is runnable once one has been chosen. This used to test `criteria.fy`, which
    // is only ever set on `defaultCriteria` - so it was always null and the View Report
    // chip was permanently disabled on this screen.
    validateCriteria() {
      return !!this.reportConfig.route;
    },
    getAuthToken() {
      return getRawJwt();
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('tax/taxRollAdjustments', [
      'getTaxTypes',
    ]),
    showReportConfig(configField) {
      return this.reportConfig.filters[configField];
    },
    selectedTaxDistricts(val) {
      this.criteria.taxDistricts = val;
      this.criteriaStats.allTaxDistricts = (val || []).length === this.taxDistrictList.length;
    },
    selectedTaxTypes(val) {
      this.criteria.taxType = val;
      this.criteriaStats.allTaxTypes = (val || []).length === this.taxTypes.length;
    },
    selectedTaxYears(val) {
      this.criteria.taxYears = val;
    },
    // Both lists start fully selected, which is the same thing as no filter - so adding
    // these controls cannot narrow a report anyone is running today until they touch them.
    loadTaxDistricts() {
      return this.loadTaxDistrict({ criteria: {}, baseCrudKey: taxDistrictBaseCrudKey })
        .then(() => {
          this.criteria.taxDistricts = this.taxDistrictList.map((item) => item.districtCode);
          this.criteriaStats.allTaxDistricts = true;
        });
    },
    async loadTaxTypes() {
      const types = await this.getTaxTypes();
      const list = [];
      const selected = [];
      (types || []).forEach((item) => {
        if (!item) return;
        list.push({ name: `${item.toUpperCase()} - ${typesDefination[item] || ''}`, value: item.toUpperCase() });
        selected.push(item.toUpperCase());
      });
      this.taxTypes = list;
      this.criteria.taxType = selected;
      this.criteriaStats.allTaxTypes = true;
    },
    async initializeTaxYear() {
      const item = await this.loadTaxYearList({ postProcessTrans: this.postProccessTaxYearData });
      const data = [];
      const taxYears = [];

      // eslint-disable-next-line array-callback-return
      item.map((val) => {
        data.push({
          taxYear: val,
        });
        taxYears.push(val);
      });
      this.taxYearsList = data;
      this.criteria.taxYears = taxYears;
      return data;
    },
  },
};

</script>
